import type { LayoutPageConfig } from './types';

export const processingPageConfig = {
  namespacesRequired: ['processing'],
  layout: {},
} satisfies LayoutPageConfig;
